import { render } from "./CustomerDataPage.vue?vue&type=template&id=728f3273&scoped=true"
import script from "./CustomerDataPage.vue?vue&type=script&lang=js"
export * from "./CustomerDataPage.vue?vue&type=script&lang=js"

import "./CustomerDataPage.vue?vue&type=style&index=0&id=728f3273&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728f3273"]])

export default __exports__